<div class="pl-4 text-24 text-qr_color-gray_2 font-semibold">
  {{headline}}
</div>
